// @flow strict

import * as React from 'react';
import getNodeDimensions from 'get-node-dimensions';

type PropTypes = {|
  open: boolean,
  height?: number,
  children: React.Node,
|};

export default (props: PropTypes) => {
  const ref = React.useRef();
  const [animateStyles, setAnimateStyles] = React.useState({
    height: '0',
    transition: 'height 256ms ease-in-out, visibility 256ms ease-in-out',
    overflow: 'hidden',
    visibility: 'hidden',
  });

  React.useLayoutEffect(() => {
    if (props.open) {
      const dimensions = ref.current && getNodeDimensions(ref.current);
      const height = dimensions ? `${dimensions.height}px` : 'auto';
      const visibility = 'visible';
      setAnimateStyles(
        Object.assign(
          {
            height: '0',
            transition: 'height 256ms ease-in-out, visibility 256ms ease-in-out',
            overflow: 'hidden',
            visibility: 'hidden',
          },
          { height: props.height ? `${props.height}px` : height, visibility },
        ),
      );
      return;
    }

    setAnimateStyles({
      height: '0',
      transition: 'height 256ms ease-in-out, visibility 256ms ease-in-out',
      overflow: 'hidden',
      visibility: 'hidden',
    });
  }, [ref.current, props.open, props.children, props.height]);

  return (
    <div ref={ref} style={animateStyles}>
      {props.children}
    </div>
  );
};
